import { createContext, useContext } from "react";

import { DischargeFormModel } from "./DischargeFormModel.ts";

export const DischargeContext = createContext<DischargeFormModel>(
  {} as DischargeFormModel
);

export const useDischargeContext = () => useContext(DischargeContext);
